import useAppToast from '@/hooks/useAppToast';
import { getRezeptLimitList } from '@/services/admin/rezeptLimitService';
import type { RezeptLimitListQuery } from '@/types/admin-rezept-limit';
import { getApiErrorMessage, DEFAULT_FETCH_ERROR_MESSAGE } from '@/utils/apiError';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Fetches paginated rezept limits list for admin.
 * Shows toast on fetch error.
 */
export const useAdminRezeptLimitList = (query: RezeptLimitListQuery) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const toast = useAppToast();

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['rezept-limits', currentSite, query],
    queryFn: () => getRezeptLimitList(currentSite, query),
    enabled: !!currentSite,
    staleTime: 30_000,
  });

  useEffect(() => {
    if (isError && error) {
      toast.error(getApiErrorMessage(error, DEFAULT_FETCH_ERROR_MESSAGE));
    }
  }, [isError, error, toast]);

  return { data, isLoading, isError, refetch, error };
};
